/* Kurotsuki theme: mobile menu, header state, add to cart + mini cart (Shopify Ajax API) */
(function(){
  var CFG = window.KT_CFG || { currency: "EUR", freeFrom: 7500, set: null, kniveHandles: [] };
  function qs(s, r){ return (r || document).querySelector(s); }
  function qsa(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t){ return String(t == null ? "" : t).replace(/[&<>"]/g, function(c){ return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(cents){
    try { return new Intl.NumberFormat("nl-NL", { style: "currency", currency: CFG.currency || "EUR" }).format(cents / 100); }
    catch(e){ return "€ " + (cents / 100).toFixed(2).replace(".", ","); }
  }

  /* ---------- side menu (left drawer) ---------- */
  var toggle = qs("[data-nav-toggle]"), menu = qs("[data-mobile-menu]"), closeBtn = qs("[data-mobile-menu-close]"), backdrop = qs("[data-menu-backdrop]");
  if(toggle && menu){
    var setMenu = function(open){
      menu.classList.toggle("open", open);
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if(backdrop){ backdrop.hidden = false; backdrop.classList.toggle("show", open); if(!open) setTimeout(function(){ if(!menu.classList.contains("open")) backdrop.hidden = true; }, 300); }
      document.body.classList.toggle("menu-open", open);
      if(open){ var first = qs("nav a", menu); if(first) first.focus(); } else { toggle.focus(); }
    };
    toggle.addEventListener("click", function(){ setMenu(true); });
    if(closeBtn) closeBtn.addEventListener("click", function(){ setMenu(false); });
    if(backdrop) backdrop.addEventListener("click", function(){ setMenu(false); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape" && menu.classList.contains("open")) setMenu(false); });
    qsa("a", menu).forEach(function(a){ a.addEventListener("click", function(){ menu.classList.remove("open"); document.body.classList.remove("menu-open"); if(backdrop){ backdrop.classList.remove("show"); backdrop.hidden = true; } }); });
  }

  /* ---------- transparent header on the hero ---------- */
  var header = qs(".header-overlay");
  if(header){
    var onScroll = function(){ var on = window.scrollY > 40; header.classList.toggle("scrolled", on); header.classList.toggle("is-scrolled", on); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- toast ---------- */
  function toast(msg){
    var t = qs(".toast");
    if(!t){ t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toast._t); toast._t = setTimeout(function(){ t.classList.remove("show"); }, 2400);
  }
  window.ktToast = toast;

  /* ---------- cart badge ---------- */
  function setCount(n){
    qsa("[data-cart-count]").forEach(function(el){ el.textContent = n; el.hidden = n === 0; });
  }

  /* ---------- mini cart (drawer) ---------- */
  var drawer, overlay, bodyEl, footEl;
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12h10l1-12M9 7V4h6v3"/></svg>';

  function buildDrawer(){
    var host = document.createElement("div");
    host.innerHTML =
      '<div class="drawer-overlay" data-drawer-overlay hidden></div>' +
      '<aside class="cart-drawer" data-cart-drawer role="dialog" aria-modal="true" aria-label="Winkelwagen" aria-hidden="true">' +
        '<div class="cart-drawer-head"><h2>Jouw winkelwagen</h2><button type="button" class="icon-btn" data-drawer-close aria-label="Sluit winkelwagen">' + ICON_CLOSE + '</button></div>' +
        '<div class="cart-drawer-body" data-drawer-items></div>' +
        '<div class="cart-drawer-foot" data-drawer-foot></div>' +
      '</aside>';
    while(host.firstChild) document.body.appendChild(host.firstChild);
    drawer = qs("[data-cart-drawer]"); overlay = qs("[data-drawer-overlay]");
    bodyEl = qs("[data-drawer-items]"); footEl = qs("[data-drawer-foot]");
    overlay.addEventListener("click", closeDrawer);
    qs("[data-drawer-close]").addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeDrawer(); });
    bodyEl.addEventListener("click", function(e){
      var b = e.target.closest("button[data-line]");
      if(!b) return;
      changeLine(b.getAttribute("data-line"), b.getAttribute("data-qty"));
    });
  }

  function upsellHTML(cart){
    // tip: one of the two knives in the cart and not the set -> suggest the set
    var set = CFG.set;
    if(!set || !set.available) return "";
    var handles = cart.items.map(function(i){ return i.handle; });
    if(handles.indexOf(set.handle) !== -1) return "";
    var knives = (CFG.kniveHandles || []).filter(function(h){ return handles.indexOf(h) !== -1; });
    if(knives.length !== 1) return "";
    var save = set.compare > set.price ? set.compare - set.price : 0;
    return '<a class="kt-upsell" href="' + esc(set.url) + '">' +
      (set.image ? '<img src="' + esc(set.image) + '" alt="">' : '') +
      '<span><strong>Liever beide Gyuto\'s?</strong><br>' + esc(set.title) + ' voor ' + money(set.price) + (save ? ' <em>(je bespaart ' + money(save) + ')</em>' : '') + '</span></a>';
  }

  function shippingBarHTML(total){
    var from = CFG.freeFrom || 0;
    if(!from) return "";
    var left = Math.max(0, from - total);
    var pct = Math.min(100, Math.round(total / from * 100));
    var msg = left > 0 ? 'Nog <strong>' + money(left) + '</strong> tot gratis verzending' : 'Je krijgt <strong>gratis verzending</strong>';
    return '<div class="kt-ship"><p>' + msg + '</p><div class="kt-ship-bar"><span style="width:' + pct + '%"></span></div></div>';
  }

  function renderDrawer(cart){
    if(!drawer) return;
    if(!cart.items.length){
      bodyEl.innerHTML = '<div class="drawer-empty"><p>Je winkelwagen is nog leeg.</p><a class="btn btn-outline btn-sm" href="/collections/all">Naar de shop</a></div>';
      footEl.hidden = true;
      return;
    }
    footEl.hidden = false;
    bodyEl.innerHTML = shippingBarHTML(cart.total_price) + cart.items.map(function(i, idx){
      var line = idx + 1;
      return '<div class="drawer-item">' +
        '<div class="drawer-thumb">' + (i.featured_image && i.featured_image.url ? '<img src="' + esc(i.featured_image.url.replace(/(\.\w+)(\?|$)/, "_160x$1$2")) + '" alt="">' : '') + '</div>' +
        '<div class="drawer-info"><a class="drawer-name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><span class="drawer-price">' + money(i.final_price) + '</span></div>' +
        '<div class="drawer-qty"><button type="button" aria-label="Verlaag aantal" data-line="' + line + '" data-qty="' + (i.quantity - 1) + '">&minus;</button><span aria-live="polite">' + i.quantity + '</span><button type="button" aria-label="Verhoog aantal" data-line="' + line + '" data-qty="' + (i.quantity + 1) + '">+</button></div>' +
        '<button type="button" class="drawer-remove" aria-label="Verwijder ' + esc(i.product_title) + '" data-line="' + line + '" data-qty="0">' + ICON_TRASH + '</button>' +
      '</div>';
    }).join("") + upsellHTML(cart);
    footEl.innerHTML =
      '<div class="drawer-subtotal"><span>Subtotaal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="drawer-note">Verzendkosten en kortingscodes zie je bij het afrekenen</p>' +
      '<a class="btn btn-gold btn-block" href="/checkout">Naar afrekenen <span aria-hidden="true">→</span></a>' +
      '<div class="kt-drawer-links"><a href="/cart">Winkelwagen bekijken</a><button type="button" data-drawer-continue>Verder winkelen</button></div>';
    var cont = qs("[data-drawer-continue]", footEl);
    if(cont) cont.addEventListener("click", closeDrawer);
  }

  function getCart(){
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function(r){ return r.json(); });
  }
  function refresh(){
    return getCart().then(function(c){ setCount(c.item_count); renderDrawer(c); return c; });
  }
  function changeLine(line, qty){
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty) || 0) })
    }).then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); renderDrawer(c); });
  }

  function openDrawer(){
    if(!drawer) buildDrawer();
    refresh().then(function(){
      overlay.hidden = false;
      requestAnimationFrame(function(){ drawer.classList.add("open"); overlay.classList.add("open"); });
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("drawer-open");
    });
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove("open"); overlay.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("drawer-open");
    setTimeout(function(){ if(!drawer.classList.contains("open")) overlay.hidden = true; }, 300);
  }
  window.ktOpenCart = openDrawer;

  // cart icon opens the mini cart, except on the cart page itself
  if(!/^\/cart\/?$/.test(location.pathname)){
    qsa('a[aria-label="Winkelwagen"]').forEach(function(a){
      a.addEventListener("click", function(e){ e.preventDefault(); openDrawer(); });
    });
  }

  /* ---------- add to cart buttons: <button data-add-to-cart="VARIANT_ID" [data-use-qty]> ---------- */
  function addToCart(id, qty, btn){
    if(btn) btn.disabled = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    }).then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if(btn) btn.disabled = false;
        if(!res.ok){ toast(res.j.description || "Toevoegen is niet gelukt."); return; }
        openDrawer();
      }).catch(function(){ if(btn) btn.disabled = false; toast("Er ging iets mis. Probeer het opnieuw."); });
  }
  window.ktAddToCart = addToCart;

  document.addEventListener("click", function(e){
    var btn = e.target.closest("[data-add-to-cart]");
    if(!btn) return;
    e.preventDefault();
    var qtyInput = btn.hasAttribute("data-use-qty") ? qs("#qty-input") : null;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    addToCart(btn.getAttribute("data-add-to-cart"), qty, btn);
  });

  /* ---------- quantity stepper on the product page ---------- */
  document.addEventListener("click", function(e){
    var m = e.target.closest("#qty-minus"), p = e.target.closest("#qty-plus"), q = qs("#qty-input");
    if(!q || (!m && !p)) return;
    q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (p ? 1 : -1));
  });
})();
